import { render, staticRenderFns } from "./LeavingConfirm.vue?vue&type=template&id=4a0b504b&scoped=true"
import script from "./LeavingConfirm.vue?vue&type=script&lang=js"
export * from "./LeavingConfirm.vue?vue&type=script&lang=js"
import style0 from "./LeavingConfirm.vue?vue&type=style&index=0&id=4a0b504b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b504b",
  null
  
)

export default component.exports